import JSONStateBounds from "../assets/data/stateBounds.json"

export default function getStateBoundsData() {
  return JSONStateBounds
}
